function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Transforms the given coordinates using action_route=Coordinates and updates coordinates to the UI
 * @method getTransformedCoordinates
 * @param {Object} data: {lonlat: lat: '', lon: ''} coordinates to be transformed
 * @param {String} srs: projection for given lonlat params like "EPSG:4326"
 * @param {String} targetSRS: projection to transform to like "EPSG:4326"
 * @param {Function} successCb success callback
 * @param {Function} errorCb error callback
 */
export var getTransformedCoordinates = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(originalProjection, data, srs, targetSRS) {
    var map;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!data) {
            map = Oskari.getSandbox().getMap();
            data = {
              'lonlat': {
                'lat': parseFloat(map.getY()),
                'lon': parseFloat(map.getX())
              }
            };
          }

          // If coordinates are empty then not try to transform these
          if (!(typeof data.lonlat.lon === 'undefined' && typeof data.lonlat.lat === 'undefined' || data.lonlat.lon === '' && data.lonlat.lat === '')) {
            _context.n = 1;
            break;
          }
          throw new Error('Cannot transform coordinates');
        case 1:
          if (!srs) {
            srs = originalProjection;
          }
          if (!(srs !== targetSRS)) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return jQuery.ajax({
            url: Oskari.urls.getRoute('Coordinates'),
            data: {
              lat: data.lonlat.lat,
              lon: data.lonlat.lon,
              srs: srs,
              targetSRS: targetSRS
            }
          });
        case 2:
          return _context.a(2, _context.v);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function getTransformedCoordinates(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Transforms the given coordinates
 * @method @public transformCoordinates
 * @param {Object} data: lat/lon coordinates to be transformed
 * @param {String} srs: projection for given lonlat params like "EPSG:4326"
 * @param {String} targetSRS: projection to transform to like "EPSG:4326"
 * @return {Object} data: transformed coordinates as object with lon and lat keys
 */
export var transformCoordinates = function transformCoordinates(mapModule, data, srs, targetSRS) {
  if (!data) {
    var map = Oskari.getSandbox().getMap();
    data = {
      'lonlat': {
        'lat': parseFloat(map.getY()),
        'lon': parseFloat(map.getX())
      }
    };
  }
  if (!srs) {
    srs = mapModule.getProjection();
  }
  try {
    if (srs && targetSRS) {
      data.lonlat = mapModule.transformCoordinates(data.lonlat, srs, targetSRS);
    }
  } catch (e) {
    throw new Error();
  }
  return data;
};

/**
 * format different degree presentations of lon/lat coordinates
 */
export var formatDegrees = function formatDegrees(lon, lat, type, accuracy) {
  var degreesX, degreesY, minutesX, minutesY, secondsX, secondsY;
  switch (type) {
    case 'min':
      degreesX = parseInt(lon);
      degreesY = parseInt(lat);
      // defaults to 5 and 0 ?? 5 = 0 (undefined ?? 5 = 5)
      minutesX = Number((lon - degreesX) * 60).toFixed(accuracy !== null && accuracy !== void 0 ? accuracy : 5);
      minutesY = Number((lat - degreesY) * 60).toFixed(accuracy !== null && accuracy !== void 0 ? accuracy : 5);
      return {
        degreesX: degreesX,
        degreesY: degreesY,
        minutesX: minutesX.replace('.', Oskari.getDecimalSeparator()),
        minutesY: minutesY.replace('.', Oskari.getDecimalSeparator())
      };
    case 'sec':
      degreesX = parseInt(lon);
      degreesY = parseInt(lat);
      minutesX = parseFloat((lon - degreesX) * 60);
      minutesY = parseFloat((lat - degreesY) * 60);
      // Note! Default to 3 instead of 5
      secondsX = parseFloat((minutesX - parseInt(minutesX)) * 60).toFixed(accuracy !== null && accuracy !== void 0 ? accuracy : 3);
      secondsY = parseFloat((minutesY - parseInt(minutesY)) * 60).toFixed(accuracy !== null && accuracy !== void 0 ? accuracy : 3);
      return {
        degreesX: degreesX,
        degreesY: degreesY,
        minutesX: parseInt(minutesX),
        minutesY: parseInt(minutesY),
        secondsX: secondsX.replace('.', Oskari.getDecimalSeparator()),
        secondsY: secondsY.replace('.', Oskari.getDecimalSeparator())
      };
  }
};
export var isTransformAllowed = function isTransformAllowed() {
  var supportedProjections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.isArray(supportedProjections) && supportedProjections.length > 1;
};